/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentTimelineStageTypeSchema = z.enum([
  "RegistrationClosed",
  "CheckIn",
  "Round1",
  "Round2",
  "Round3",
  "Round4",
  "Round5",
  "Semifinal",
  "Final",
  "Awarding",
  "Custom",
]);
